var driverClassifyOptions = [
    {
        label: '自营',
        val: 'SELFSUPPORT',
    },
    {
        label: '签约',
        val: 'SIGNED',
    },
    {
        label: '加盟',
        val: 'JOIN',
    },
];
var sexOptions = [
    {
        label: '男',
        val: 'MALE',
    },
    {
        label: '女',
        val: 'FEMALE',
    },
];
var drivingLicenceTypeOptions = [
    {
        val: 'C1',
    },
    {
        val: 'C2',
    },
    {
        val: 'B1',
    },
    {
        val: 'B2',
    },
    {
        val: 'B3',
    },
    {
        val: 'A1',
    },
    {
        val: 'A2',
    },
    {
        val: 'A3',
    },
];
var classifyName = {
    SELFSUPPORT: '自营',
    SIGNED: '签约',
    JOIN: '加盟',
};
var sexName = {
    MALE: '男',
    FEMALE: '女',
};
export { driverClassifyOptions, drivingLicenceTypeOptions, sexOptions, classifyName, sexName };
